import React from 'react';
import { updateParent } from '../../lib/modal';
import { defaultMerchant, platform, loadApplyNow, applyNowKeys } from '../../constants/SiteVariables';
import { calculate_as_low_as_payment } from '../../lib/utils'
import PromoImage from '../shared/PromoImage';
import { isValidCharges, isValidPublicKey } from '../../lib/validations';

export default function CartBanner({ match }) {

  let desktop = match.params.desktop
  let mobile = match.params.mobile

  const [total, shipping, tax, discount_amount, grand_total] = match.params.charges ? match.params.charges.split(',') : [0, 0, 0, 0, 0]

  if (isValidCharges(match.params.charges.split(',')) === false) {
    console.error("Invalid charges format. Please check that you have provided a valid charges object.")
    return (
      null
    )
  } else if (isValidPublicKey(match.params.public_key) === false) {
    console.error("Invalid public key. Please check that you have provided a valid public key.")
    return (
      null
    )
  } else {

    let calc = calculate_as_low_as_payment(grand_total ? grand_total : 0)

    const loadEnhancedPdpModal = () => {
      updateParent('pdp', {
        public_key: match.params.public_key ? match.params.public_key : defaultMerchant(),
        charges: [total, shipping, tax, discount_amount, grand_total] ? [total, shipping, tax, discount_amount, grand_total] : null,
        platform: platform()
      });
    }

    return (
      <div className="cart-container">
        <div role="cart-promo" onClick={() => applyNowKeys.includes(match.params.public_key) ? loadApplyNow(match.params.public_key) : loadEnhancedPdpModal()} className={`desktop-${desktop} mobile-${mobile}`}>
          <div>As low as ${calc}/month </div>
          <div>Select  <PromoImage /> at checkout </div>
        </div>
      </div>
    )
  }

}


